export default "__VITE_ASSET__a318b742__"